import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/thumbs-down': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M466.3 225.3C470.9 202.7 467.1 180.8 457.3 162.3 460.2 138.5 453.3 113.8 439.9 95.3 439 39.4 404.1 0 327 0 320 0 312 0 304.8 0 201.2 0 169 40 128 40H117.2C111.5 35 104.1 32 96 32H32C14.3 32 0 46.3 0 64V304C0 321.7 14.3 336 32 336H96C107.8 336 118.2 329.6 123.7 320H130.8C149.9 337 176.8 380.7 199.5 403.4 213.2 417.1 209.7 512 271.3 512 328.9 512 366.6 480.1 366.6 407.3 366.6 388.9 362.6 373.5 357.7 360.7H394.2C442.8 360.7 480 319.2 480 275.1 480 256 475 240.2 466.3 225.3zM64 296C50.7 296 40 285.3 40 272S50.7 248 64 248 88 258.7 88 272 77.3 296 64 296zM394.2 312.7H290.2C290.2 350.6 318.6 368.1 318.6 407.3 318.6 431 318.6 464 271.3 464 252.4 445.1 261.8 397.8 233.5 369.5 206.9 342.9 167.3 272 138.9 272H128V85.8C181.6 85.8 228 48 299.6 48H337.5C373 48 398.3 65.1 390.6 113.9 405.8 122.1 417.1 150.4 404.5 171.5 426.1 191.9 423.2 222.5 409.7 237.1 419.2 237.1 432.1 256 432 274.9 431.9 293.8 415.3 312.7 394.2 312.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/thumbs-down.js
// module id = hGBR
// module chunks = 144